import { COMPANY, LAWYER } from '@shared/constants/ProfileProductId';
import { useI18n } from 'vue-i18n';
import { SEX } from '@shared/types/Sex';

export const TranslationHelper = () => {
  const { t } = useI18n();
  const getTranslationByProductId = (
    translationPath: string,
    profileProductId: typeof LAWYER | typeof COMPANY,
    data: object
  ) => {
    return t(`${translationPath}.${profileProductId}`, { ...data });
  };

  const getGenderValueForTranslation = (sex: SEX) => {
    return sex === SEX.MALE ? 1 : 2;
  };

  return {
    getTranslationByProductId,
    getGenderValueForTranslation,
  };
};
